import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { errorMessageAreaStyles } from "./styles/business-components";

export const NotFound = () => {
  const { t } = useTranslation();
  
  return (
    <Box>
      <Box sx={errorMessageAreaStyles.main}>
        <Typography>{t('notFound.pageNotFound')}</Typography>
      </Box>
    </Box>
  );
};

export default NotFound;
